export function SwitchIcon() {
  return (
    <svg width="96" height="48" viewBox="0 0 96 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_244_2560)">
        <rect width="96" height="48" rx="24" fill="#F5F6FA"/>
        <g filter="url(#filter0_dddd_244_2560)">
          <path
            d="M4 24C4 12.9543 12.9543 4 24 4C35.0457 4 44 12.9543 44 24C44 35.0457 35.0457 44 24 44C12.9543 44 4 35.0457 4 24Z"
            fill="#A4AABF"/>
        </g>
      </g>
      <defs>
        <filter id="filter0_dddd_244_2560" x="-32" y="-6" width="78" height="60" filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB">
          <feFlood floodOpacity="0" result="BackgroundImageFix"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                         result="hardAlpha"/>
          <feOffset dx="-2"/>
          <feGaussianBlur stdDeviation="2"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.0705882 0 0 0 0 0.203922 0 0 0 0.08 0"/>
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_244_2560"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                         result="hardAlpha"/>
          <feOffset dx="-6"/>
          <feGaussianBlur stdDeviation="3"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.0705882 0 0 0 0 0.203922 0 0 0 0.07 0"/>
          <feBlend mode="normal" in2="effect1_dropShadow_244_2560" result="effect2_dropShadow_244_2560"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                         result="hardAlpha"/>
          <feOffset dx="-14"/>
          <feGaussianBlur stdDeviation="4.5"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.0705882 0 0 0 0 0.203922 0 0 0 0.04 0"/>
          <feBlend mode="normal" in2="effect2_dropShadow_244_2560" result="effect3_dropShadow_244_2560"/>
          <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                         result="hardAlpha"/>
          <feOffset dx="-26"/>
          <feGaussianBlur stdDeviation="5"/>
          <feColorMatrix type="matrix" values="0 0 0 0 0.0352941 0 0 0 0 0.0705882 0 0 0 0 0.203922 0 0 0 0.01 0"/>
          <feBlend mode="normal" in2="effect3_dropShadow_244_2560" result="effect4_dropShadow_244_2560"/>
          <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_244_2560" result="shape"/>
        </filter>
        <clipPath id="clip0_244_2560">
          <rect width="96" height="48" rx="24" fill="white"/>
        </clipPath>
      </defs>
    </svg>

  )
}